import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import React, { Component } from 'react'
import { Modal } from 'antd'
import BookingForm from './OrderLineForm'

class OrderLineModal extends Component {
  render () {
    const {
      visibleLine,
      updatingBooking,
      onCancelLine,
      submitLine,
      updateLine,
      modalType,
      lineFormRef,
      removeLine,
      removingLine,
      isUpdatable,
      line,
    } = this.props

    return (
      <Modal
        width={'75%'}
        visible={visibleLine}
        title={modalType === 'new' ? 'Add Line' : 'Edit Line'}
        onCancel={onCancelLine}
        destroyOnClose={true}
        confirmLoading={updatingBooking}
        footer={
          <FooterButtons
            visible={isUpdatable}
            remove={() => removeLine(line.key || line._id)}
            removing={removingLine}
            submit={submitLine}
            update={updateLine}
            submitting={updatingBooking}
            title={'order line'}
            isNew={modalType === 'new'}
            isEdit={modalType !== 'new'}
          />
        }>
        <BookingForm {...this.props} />
      </Modal>
    )
  }
}

OrderLineModal.propTypes = {}
OrderLineModal.defaultProps = {}

export default OrderLineModal
